import { Container, Text } from "@mantine/core";
import { EditPicture } from "ui";
import type { EditPictureOrigin } from "ui/EditPicture/EditPicture";

interface EventFormPictureProps {
  eventPicture?: string | undefined;
  /** The cropped file and where it came from (EditPictureOrigin, AD-CR-03). */
  setFile: (file: File | undefined, origin: EditPictureOrigin) => void;
  missingPicture: boolean;
  setMissingPicture: (value: boolean) => void;
  t: (key: string) => string;
  isApplicationEdit?: boolean;
  /**
   * Forwarded straight to `EditPicture`. Screenshot-pixel geometry from
   * `ApplicationContext.artworkRect`; undefined for manual event creation,
   * which passes no application context at all.
   */
  initialCroppedAreaPixels?: {
    x: number;
    y: number;
    width: number;
    height: number;
  };
}

export const EventFormPicture = ({
  eventPicture,
  setFile,
  missingPicture,
  setMissingPicture,
  t,
  isApplicationEdit = false,
  initialCroppedAreaPixels,
}: EventFormPictureProps) => {
  return (
    <Container mt="md">
      <EditPicture
        label={`${t("events.event_picture")} *`}
        defaultValue={eventPicture}
        onChange={(file, origin) => {
          setFile(file, origin);
          setMissingPicture(false);
        }}
        width={300}
        height={300}
        isError={missingPicture}
        isApplicationEdit={isApplicationEdit}
        initialCroppedAreaPixels={initialCroppedAreaPixels}
      />
      {missingPicture && (
        <Text color="red" size="sm" mt="xs" style={{ textAlign: "center" }}>
          {t("events.picture_required")}
        </Text>
      )}
    </Container>
  );
};
